export const DATE_ENUMS = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
};
